import React                from 'react';

import Alert                from '../utils/Alert';
import * as MenuItem        from '../components/MenuItem';
import intelitransit        from '../utils/InteliTransit';

interface Props {
}

interface State {
    id  : string;
}

export default class NewApplication extends React.Component<Props,State> {
    private alert : Alert = new Alert();
    static newId = () : string => {
        return `${Date.now()}${Math.round(100*Math.random())}`.substring(1);
    }
    constructor( props:Props ) {
        super(props);
        this.state = {
            id : NewApplication.newId()
        };
    }
    render() {
        return MenuItem.withMenuItem("New Application Link",( alert_ ) => {
            this.alert = alert_;
            return (
                <div className="content">
                    <table width="80%" style={{padding:"50px"}}>
                    <tbody>
                        <tr>
                            <td colSpan={2}>
                                <input
                                    id        = "applicationLink" 
                                    type      = "text"
                                    className = "input-theme input-theme-min"
                                    size      = {40}
                                    readOnly  = {true}
                                    value     = {`${intelitransit.agency.publicUrl}/Applicant/AEVApplication/${this.state.id}`}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <button className="btn-theme btn-min" onClick={(e:React.MouseEvent<HTMLButtonElement>)=>{
                                    this.setState({
                                        id : NewApplication.newId()
                                    })
                                }}>Refresh</button>
                            </td>
                            <td>
                                <button className="btn-theme btn-min" onClick={(e:React.MouseEvent<HTMLButtonElement>)=>{
                                    const inputElement = document.getElementById("applicationLink") as HTMLInputElement;                                    
                                    // Copy the input's value to the clipboard
                                    navigator.clipboard.writeText(inputElement.value)
                                        .then(() => {
                                            this.alert.set("Text copied to clipboard!",5000);
                                        })
                                        .catch(err => {
                                            this.alert.set(`Failed to copy text ${(err as Error).message}`);
                                        });                                
                                }}>Copy</button>                                
                            </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            );
        });
    }
}
